import { h, Component } from 'preact';
import { MkComponent } from 'lib/mkjs/mkcomponent';

export default class GraphEvent extends MkComponent {
}



// WEBPACK FOOTER //
// ./entities/graphevent/index.js